import { CommonModule } from '@angular/common'
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  inject,
  OnInit,
  Renderer2
} from '@angular/core'
import { NavigationEnd, Router, RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import { selectUser, selectUserPermissions } from '../../../../store/auth/auth.selectors'
import { filter, Observable } from 'rxjs'
// import { HasPermissionDirective } from '../../../../directives/has-permission.directiveOld'
import { eps } from '../../../../services/url.service'
import { AuthState, selectSubscription } from '../../../../store/auth/auth.state'
import { incomingSubscription, SubscriptionStatus } from '../../../../services/subscriptions'
import { UtilsService } from '../../../../services/utils.service'
import { HasPermissionDirective } from '../../../../directives/has-permission.directive'
import { HasModuleDirective } from '../../../../directives/has-module.directive'

export type MenuStates = 'open' | 'close'

@Component({
  selector: 'app-app-menu',
  imports: [CommonModule, RouterModule, HasPermissionDirective, HasModuleDirective],
  templateUrl: './app-menu.component.html',
  styleUrl: './app-menu.component.scss'
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppMenuComponent implements OnInit {
  store = inject(Store)
  subscription$: Observable<incomingSubscription | null> = this.store.select(selectSubscription)
  SubscriptionStatus = SubscriptionStatus
  menus: unknown
  // subMenuStates = [false]
  subMenuStates: boolean[] = new Array(9).fill(false)
  activeSubMenuIndex: number | null = null // 👈 naya: current active page ka submenu index
  currentRoute = ''
  isAdmin: boolean | undefined
  isBusinessOwner: boolean | undefined
  eps = eps //Endponits
  user: AuthState['user'] | null = null
  isSubscriptionExpired = false
  permissionsMap: Record<string, string[]> = {}

  readonly setupPermissions: Record<string, string[]>[] = [
    { department: ['view'] },
    { designation: ['view'] },
    { leavePolicy: ['view'] },
    { attendancePolicy: ['view'] },
    { earnings: ['view'] },
    { customEarnings: ['view'] },
    { customDeductions: ['view'] },
    { reimbursements: ['view'] },
    { statutoryDeductions: ['view'] }
  ]

  readonly attendancePermissions: Record<string, string[]>[] = [
    { attendance: ['view'] },
    { attendanceAdmin: ['view'] }
  ]

  readonly payrollPermissions: Record<string, string[]>[] = [
    { payroll: ['view'] },
    { payslip: ['view'] }
  ]

  readonly businessPermissions: Record<string, string[]> = { business: ['view'] } // single object wale places ke liye
  readonly employeesPermission: Record<string, string[]> = { employees: ['view'] }

  // readonly attendanceParentPermissions: Record<string, string[]>[] = [
  //   { attendance: ['view'] },
  //   { attendanceAdmin: ['view'] }
  // ]
  // readonly attendanceAdminPermission: Record<string, string[]> = { attendanceAdmin: ['view'] }
  // readonly attendanceEmployeePermissions: Record<string, string[]>[] = [{ attendance: ['view'] }]
  constructor(
    private router: Router,
    private renderer: Renderer2,
    private utilService: UtilsService,
    private cdr: ChangeDetectorRef
  ) {
    this.store.select(selectUser).subscribe(user => {
      this.user = user
      // this.isAdmin = user?.role.name === 'Admin'
      this.isAdmin = user?.userRoles?.some(ur => ur.role?.name === 'Admin')
      this.isBusinessOwner = user?.userRoles?.some(ur => ur.role?.name === 'Business Owner')
      this.cdr.markForCheck()
      // this.isBusinessOwner = user?.role?.name === 'Business Owner'
      // console.log('business owner?', user?.userRoles)

      // console.log('business data role name ',this.isBusinessOwner)
    })

    //3 aug 2026 gps
    // this.store.select(selectUserPermissions).subscribe(() => {
    //   this.subMenuStates = [...this.subMenuStates] // force re-render
    // })
  }

  // closeSidebarOverlay(): void {
  //   const sidebarOverlay = document.querySelector('.sidebar-overlay')

  //   if (sidebarOverlay?.classList.contains('opened')) {
  //     this.renderer.removeClass(sidebarOverlay, 'opened')
  //   }
  // }

  closeSidebarOverlay(): void {
    const sidebarOverlay = document.querySelector('.sidebar-overlay')
    if (sidebarOverlay?.classList.contains('opened')) {
      this.renderer.removeClass(sidebarOverlay, 'opened')
    }
    const mainWrapper = document.querySelector('.main-wrapper')
    if (mainWrapper) {
      this.renderer.removeClass(mainWrapper, 'slide-nav')
    }
  }

  // ✅ GLOBAL CLICK LISTENER
  // @HostListener('document:click', ['$event'])
  // onClickOutside(event: MouseEvent) {
  //   const sidebar = document.querySelector('.sidebar') // sidebar class
  //   const overlay = document.querySelector('.sidebar-overlay')

  //   // agar click sidebar ke andar nahi hai
  //   if (sidebar && !sidebar.contains(event.target as Node)) {
  //     this.closeSidebarOverlay()
  //   }
  // }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const sidebar = document.querySelector('.sidebar')
    const toggleBtn = document.querySelector('.mobile_btn')
    const mainWrapper = document.querySelector('.main-wrapper')

    if (!sidebar || !mainWrapper) return

    const target = event.target as Node

    const clickedInsideSidebar = sidebar.contains(target)
    const clickedToggleBtn = toggleBtn?.contains(target)

    // 🔥 IMPORTANT: toggle click ignore
    if (clickedToggleBtn) return

    // ✅ outside click
    if (
      window.innerWidth < 992 &&
      mainWrapper.classList.contains('slide-nav') &&
      !clickedInsideSidebar
    ) {
      this.closeSidebarOverlay()

      // 🔥 THIS WAS MISSING
      this.renderer.removeClass(mainWrapper, 'slide-nav')
    }
  }

  // ngOnInit(): void {
  //   //10 june 2025
  //   this.setRouteState(this.router.url) // handle initial load
  //   const subscription = JSON.parse(localStorage.getItem('subscription') || 'null')
  //   // Assuming `this.user?.businesses` is your array
  //   const hasAVRHRMS =
  //     // this.user?.businesses?.some((b: any) => b.businessName === 'AVR HRMS') ?? false
  //     this.user?.business?.businessName === 'AVR HRMS'
  //   if (subscription === null && hasAVRHRMS) {
  //     this.isSubscriptionExpired = false
  //   } else {
  //     this.isSubscriptionExpired = this.isSubscriptionExpiredWithGrace(subscription)
  //   }
  //   console.log('subscription', subscription)
  //   console.log('hasavrhrms', hasAVRHRMS)
  //   console.log('isSubscriptionExpired', this.isSubscriptionExpired)
  //   this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
  //     this.setRouteState(this.router.url)
  //     // remove class on route change
  //     const mainWrapper = document.querySelector('.main-wrapper')
  //     if (mainWrapper) {
  //       this.renderer.removeClass(mainWrapper, 'slide-nav')
  //     }
  //   })
  // }
  ngOnInit(): void {
    // this.store.select(selectUserPermissions).subscribe(perms => {
    //   this.permissionsMap = perms || {}
    //   this.cdr.markForCheck()
    // })
    this.store.select(selectUserPermissions).subscribe(perms => {
      this.permissionsMap = perms || {}

      this.setRouteState(this.router.url)

      this.cdr.markForCheck()
    })
    this.setRouteState(this.router.url)

    const subscription = JSON.parse(localStorage.getItem('subscription') || 'null')
    // Assuming `this.user?.businesses` is your array
    const hasAVRHRMS =
      this.user && this.user.business
        ? this.user?.business?.businessName === 'AVR HRMS'
        : this.isAdmin
    if (subscription === null && hasAVRHRMS) {
      this.isSubscriptionExpired = false
    } else {
      this.isSubscriptionExpired = this.isSubscriptionExpiredWithGrace(subscription)
    }
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      this.setRouteState(this.router.url)
      this.cdr.markForCheck()
      const mainWrapper = document.querySelector('.main-wrapper')
      if (mainWrapper) {
        this.renderer.removeClass(mainWrapper, 'slide-nav')
      }
    })
  }

  // Toggle the visibility of the submenu at the specified index
  // toggleSubMenu(event: Event, index: number) {
  //   event.preventDefault()
  //   // console.log('index:', index)
  //   this.subMenuStates[index] = !this.subMenuStates[index] // Toggle visibility for specific submenu
  // }

  toggleSubMenu(event: Event, index: number) {
    event.preventDefault()
    event.stopImmediatePropagation()
    if (this.currentRoute === 'company/business') {
      this.currentRoute = ''
    }
    const isCurrentlyOpen = this.subMenuStates[index]

    // Sab band karo, LEKIN active (current page ka) submenu open rehne do
    this.subMenuStates = new Array(9).fill(false)
    if (this.activeSubMenuIndex !== null) {
      this.subMenuStates[this.activeSubMenuIndex] = true
    }

    // Clicked wala toggle karo
    if (index === this.activeSubMenuIndex) {
      // active menu pe hi click hua — usko band mat karo, bas open hi rehne do
      this.subMenuStates[index] = true
    } else {
      this.subMenuStates[index] = !isCurrentlyOpen
    }
    this.cdr.markForCheck()
  }

  // getDashboardRoute(): string {
  //   // return this.user?.role === 'Admin' ? eps.dashboardPath : eps.employeeDashboardPath
  //   return this.utilService.getDashboardRoute()
  // }

  // this code is wriiten by SHIVAM
  getDashboardRoute() {
    return this.utilService.getDashboardRoute(this.user)
  }

  // closeSidebarOverlay(): void {
  //   const sidebarOverlay = document.querySelector('.sidebar-overlay')
  //   if (sidebarOverlay?.classList.contains('opened')) {
  //     this.renderer.removeClass(sidebarOverlay, 'opened')
  //   }
  // }

  private setRouteState(currentUrl: string) {
    // console.log('Current URL:', currentUrl)
    // this.subMenuStates = [] // reset all submenu states
    this.subMenuStates = new Array(9).fill(false) // reset all submenu states

    if (currentUrl.includes(eps.user.dashboardPath)) {
      this.currentRoute = eps.user.dashboardPath
      this.subMenuStates[0] = true
    } else if (currentUrl.includes(eps.user.employeeDashboardPath)) {
      this.currentRoute = eps.user.employeeDashboardPath // Set a flag for this route
      this.subMenuStates[0] = true
    } else if (currentUrl.includes(eps.user.ownerDashboardPath)) {
      this.currentRoute = eps.user.ownerDashboardPath
      this.subMenuStates[0] = true
    } else if (currentUrl.includes('/hrm/employee')) {
      this.currentRoute = 'hrm/employee' // Set a flag for this route
      this.subMenuStates[2] = true
    }
    // else if (
    //   currentUrl.includes(eps.attendance.attendanceListPath) ||
    //   currentUrl.includes(eps.attendance.employeeAttendance)
    // ) {
    //   this.currentRoute = eps.attendance.attendanceListPath // Set a flag for this route
    //   this.subMenuStates[3] = true
    // }
    else if (currentUrl.includes(eps.attendance.attendanceListPath)) {
      this.currentRoute = eps.attendance.attendanceListPath
      this.subMenuStates[3] = true
    } else if (currentUrl.includes(eps.attendance.employeeAttendance)) {
      this.currentRoute = eps.attendance.attendanceListPath // employee wala jo actual link me match hota hai
      this.subMenuStates[3] = true
    } else if (currentUrl.includes(eps.attendance.calanderPath)) {
      this.currentRoute = eps.attendance.calanderPath // Set a flag for this route
      this.subMenuStates[3] = true
    } else if (currentUrl.includes(eps.leaves.holidaysPath)) {
      this.currentRoute = eps.leaves.holidaysPath // Set a flag for this route
      this.subMenuStates[4] = true
    } else if (currentUrl.includes(eps.leaves.appliedLeavePath)) {
      this.currentRoute = eps.leaves.appliedLeavePath // Set a flag for this route
      this.subMenuStates[4] = true
    } else if (currentUrl.includes(eps.leaves.leavesRequestPath)) {
      this.currentRoute = eps.leaves.leavesRequestPath // Set a flag for this route
      this.subMenuStates[4] = true
    } else if (currentUrl.includes(eps.leaves.assignedPolicyBalancePath)) {
      this.currentRoute = eps.leaves.assignedPolicyBalancePath // Set a flag for this route
      this.subMenuStates[4] = true
    } else if (currentUrl.includes(eps.leaves.policyPath)) {
      this.currentRoute = eps.leaves.policyPath // Set a flag for this route
      this.subMenuStates[1] = true
    } else if (currentUrl.includes('/attendancepolicyList')) {
      this.currentRoute = 'attendancepolicyList' // Set a flag for this route
      this.subMenuStates[1] = true
    } else if (currentUrl.includes(eps.attendance.attendancePolicyDetailsPath)) {
      this.currentRoute = eps.attendance.policiesPath
      this.subMenuStates[1] = true
    } else if (currentUrl.includes('/company/department')) {
      this.currentRoute = 'company/department' // Set a flag for this route
      this.subMenuStates[1] = true
    } else if (currentUrl.includes('/company/designation')) {
      this.currentRoute = 'company/designation' // Set a flag for this route
      this.subMenuStates[1] = true
    } else if (currentUrl.includes(eps.leaves.policiesPath)) {
      this.currentRoute = eps.leaves.policiesPath // Set a flag for this route
      this.subMenuStates[1] = true
    } else if (currentUrl.includes(eps.leaves.assignedPolicyDetailPath)) {
      this.currentRoute = eps.leaves.assignedPolicyDetailPath // Set a flag for this route
      this.subMenuStates[1] = true
    } else if (currentUrl.includes(eps.attendance.policiesPath)) {
      this.currentRoute = eps.attendance.policiesPath // Set a flag for this route
      this.subMenuStates[1] = true
    } else if (currentUrl.includes(eps.company.salaryComponentsPath)) {
      this.currentRoute = eps.company.salaryComponentsPath // Set a flag for this route
      this.subMenuStates[1] = true
    } else if (currentUrl.includes(eps.company.taxSettingsPath)) {
      this.currentRoute = eps.company.taxSettingsPath // Set a flag for this route
      this.subMenuStates[1] = true
    } else if (currentUrl.includes('/businessownerlist')) {
      this.currentRoute = 'businessownerlist' // Set a flag for this route
      // this.subMenuStates[1] = true;
    } else if (currentUrl.includes('/company/business')) {
      this.currentRoute = 'company/business' // Set a flag for this route
      // this.subMenuStates[1] = true;
    } else if (currentUrl.includes('/officelist')) {
      this.currentRoute = 'officelist' // Set a flag for this route
      // this.subMenuStates[1] = true;
    } else if (currentUrl.includes('/joblist')) {
      this.currentRoute = 'joblist' // Set a flag for this route
      // this.subMenuStates[1] = true;
    } else if (currentUrl.includes('/candidatelist')) {
      this.currentRoute = 'candidatelist' // Set a flag for this route
      // this.subMenuStates[1] = true;
    } else if (currentUrl.includes('/userRole/role')) {
      this.currentRoute = 'userRole/role' // Set a flag for this route
      this.subMenuStates[1] = true
    } else if (currentUrl.includes(eps.role.rolePath)) {
      this.currentRoute = eps.role.rolePath // Set a flag for this route
      this.subMenuStates[1] = true
    } else if (currentUrl.includes(eps.role.roleDetailsPath)) {
      this.currentRoute = eps.role.roleDetailsPath // Set a flag for this route
      this.subMenuStates[1] = true
    } else if (currentUrl.includes(eps.permissionSet.permissionSetPath)) {
      this.currentRoute = eps.permissionSet.permissionSetPath // Set a flag for this route
      this.subMenuStates[1] = true
    } else if (currentUrl.includes(eps.permissionSet.permissionSetdetailsPath)) {
      this.currentRoute = eps.permissionSet.permissionSetdetailsPath // Set a flag for this route
      this.subMenuStates[1] = true
    } else if (currentUrl.includes(eps.hrm.managePayrollPath)) {
      this.currentRoute = eps.hrm.managePayrollPath // Set a flag for this route
      this.subMenuStates[5] = true
    } else if (currentUrl.includes(eps.hrm.runPayrollPath)) {
      this.currentRoute = eps.hrm.runPayrollPath // Set a flag for this route
      this.subMenuStates[5] = true
    } else if (currentUrl.includes(eps.hrm.investmentsPath)) {
      this.currentRoute = eps.hrm.investmentsPath // Set a flag for this route
      this.subMenuStates[5] = true
    } else if (currentUrl.includes(eps.hrm.payslipPath)) {
      this.currentRoute = eps.hrm.payslipPath // Set a flag for this route
      this.subMenuStates[5] = true
    } else if (currentUrl.includes(eps.hrm.invoicePath)) {
      this.currentRoute = eps.hrm.invoicePath // Set a flag for this route
      this.subMenuStates[5] = true
    } else if (currentUrl.includes(eps.hrm.manageContractorPayrollPath)) {
      this.currentRoute = eps.hrm.manageContractorPayrollPath // Set a flag for this route
      this.subMenuStates[5] = true
    } else if (currentUrl.includes(eps.superAdmin.plansPath)) {
      this.currentRoute = eps.superAdmin.plansPath // Set a flag for this route
      this.subMenuStates[6] = true
    } else if (currentUrl.includes(eps.superAdmin.subscribersPath)) {
      this.currentRoute = eps.superAdmin.subscribersPath // Set a flag for this route
      this.subMenuStates[6] = true
    } else if (currentUrl.includes(eps.superAdmin.couponsPath)) {
      this.currentRoute = eps.superAdmin.couponsPath // Set a flag for this route
      this.subMenuStates[6] = true
    } else if (currentUrl.includes(eps.superAdmin.cronPath)) {
      this.currentRoute = eps.superAdmin.cronPath // Set a flag for this route
      this.subMenuStates[6] = true
    } else if (currentUrl.includes(eps.notificationCampaign.base)) {
      this.currentRoute = eps.notificationCampaign.base // Set a flag for this route
      this.subMenuStates[6] = true
    } else if (currentUrl.includes('earnings')) {
      this.currentRoute = 'earnings' // Set a flag for this route
      this.subMenuStates[6] = true
    } else if (currentUrl.includes(eps.planAndBilling.planPath)) {
      this.currentRoute = eps.planAndBilling.planPath // Set a flag for this route
      this.subMenuStates[7] = true
    } else if (currentUrl.includes(eps.planAndBilling.billingPath)) {
      this.currentRoute = eps.planAndBilling.billingPath // Set a flag for this route
      this.subMenuStates[7] = true
    } else if (currentUrl.includes(eps.planAndBilling.upgradePlanPath)) {
      this.currentRoute = eps.planAndBilling.upgradePlanPath // Set a flag for this route
      this.subMenuStates[7] = true
    } else if (currentUrl.includes(eps.planAndBilling.activatePlanPath)) {
      this.currentRoute = eps.planAndBilling.activatePlanPath // Set a flag for this route
      this.subMenuStates[7] = true
    } else if (currentUrl.includes(eps.event.birthdaysPath)) {
      this.currentRoute = eps.event.birthdaysPath // Set a flag for this route
      this.subMenuStates[8] = true
    } else if (currentUrl.includes(eps.event.anniversaryPath)) {
      this.currentRoute = eps.event.anniversaryPath // Set a flag for this route
      this.subMenuStates[8] = true
    } else if (
      currentUrl.includes(eps.hrm.reviseSalaryPath) ||
      currentUrl.includes(eps.hrm.updateSalaryPath)
    ) {
      this.currentRoute = eps.hrm.employeePath // Set a flag for this route
      this.subMenuStates[2] = true
    } else if (currentUrl.includes(eps.user.employeeRequestPath)) {
      this.currentRoute = eps.user.employeeRequestPath // Set a flag for this route
      // this.subMenuStates[1] = true;
    } else if (currentUrl.includes(eps.user.orgChartPath)) {
      this.currentRoute = eps.user.orgChartPath // Set a flag for this route
      // this.subMenuStates[1] = true;
    } else {
      this.currentRoute = '' // Clear the flag
    }

    this.activeSubMenuIndex = this.subMenuStates.findIndex(state => state === true)
    if (this.activeSubMenuIndex === -1) this.activeSubMenuIndex = null
    // ... repeat logic for other routes
  }

  get isDashboardActive(): boolean {
    const setupRoutes = [
      eps.user.dashboardPath,
      eps.user.employeeDashboardPath,
      eps.user.ownerDashboardPath
    ]
    return setupRoutes.some(path => this.router.url.includes(path))
  }

  get isSuperAdminActive(): boolean {
    const setupRoutes = [
      eps.superAdmin.plansPath,
      eps.superAdmin.subscribersPath,
      eps.superAdmin.couponsPath,
      eps.superAdmin.cronPath,
      eps.notificationCampaign.base,
      'earnings'
    ]
    return setupRoutes.some(path => this.router.url.includes(path))
  }

  get isSetupActive(): boolean {
    const setupRoutes = [
      'company/department',
      'company/designation',
      this.eps.leaves.policiesPath,
      this.eps.attendance.policiesPath,
      this.eps.company.salaryComponentsPath,
      this.eps.company.taxSettingsPath,
      this.eps.role.rolePath,
      this.eps.permissionSet.permissionSetPath,
      this.eps.attendance.attendancePolicyDetailsPath
    ]
    return setupRoutes.some(path => this.router.url.includes(path))
  }

  // get isEmployeeActive(): boolean {
  //   const setupRoutes = [eps.hrm.employeePath]
  //   return setupRoutes.some(path => this.router.url.includes(path))
  // }

  // get isAttendanceActive(): boolean {
  //   const setupRoutes = [eps.attendance.attendanceListPath, eps.attendance.calanderPath]
  //   return setupRoutes.some(path => this.router.url.includes(path))
  // }

  private readonly employeeActiveRoutes = [eps.hrm.employeePath]
  private readonly attendanceActiveRoutes = [
    eps.attendance.attendanceListPath,
    eps.attendance.calanderPath
  ]

  get isEmployeeActive(): boolean {
    return this.employeeActiveRoutes.some(path => this.router.url.includes(path))
  }

  get isAttendanceActive(): boolean {
    return this.attendanceActiveRoutes.some(path => this.router.url.includes(path))
  }

  get isLeavesActive(): boolean {
    const setupRoutes = [
      eps.leaves.holidaysPath,
      eps.leaves.appliedLeavePath,
      eps.leaves.leavesRequestPath,
      eps.leaves.assignedPolicyBalancePath
    ]
    return setupRoutes.some(path => this.router.url.includes(path))
  }

  get isPayrollActive(): boolean {
    const setupRoutes = [
      eps.hrm.managePayrollPath,
      eps.hrm.investmentsPath,
      eps.hrm.payslipPath,
      eps.hrm.manageContractorPayrollPath,
      eps.hrm.runPayrollPath
    ]
    return setupRoutes.some(path => this.router.url.includes(path))
  }

  get isPlansAndBillingActive(): boolean {
    const setupRoutes = [
      eps.planAndBilling.planPath,
      eps.planAndBilling.billingPath,
      eps.planAndBilling.upgradePlanPath,
      eps.planAndBilling.activatePlanPath
    ]
    return setupRoutes.some(path => this.router.url.includes(path))
  }

  get isEventsActive(): boolean {
    const setupRoutes = [eps.event.birthdaysPath, eps.event.anniversaryPath]
    return setupRoutes.some(path => this.router.url.includes(path))
  }

  isSubscriptionExpiredWithGrace(subscription: any) {
    if (!subscription?.expiryDate) return true

    const expiryDate = new Date(subscription.expiryDate)

    // Add 48 hours (grace period)
    const expiryWithGrace = new Date(expiryDate.getTime() + 48 * 60 * 60 * 1000)

    const now = new Date()

    return now > expiryWithGrace
  }
}
